import { ElasticFilterType, KibanaFilterType } from '../filter-interfaces';
import KibanaLookupFilterMetadata from '../metadatas/osd-lookup-filter-metadata';
import LookupFilterModel from '../models/lookup-filter-model';
import BaseFilterParser from './base-filter-parser';
/**
 * Elastic to Kibana 'LOOKUP' filter parser
 */
class LookupFilterParser extends BaseFilterParser {
    constructor() {
        super(KibanaFilterType.Lookup, ElasticFilterType.Lookup);
    }
    getMetadata(filter, negate = false, indexPattern) {
        let retVal = null;
        if (filter.lookup) {
            const { id, name, field: key, alertEventId } = filter.lookup;
            retVal = new KibanaLookupFilterMetadata(id, name, key, negate, alertEventId, indexPattern);
        }
        return retVal;
    }
    getFilter(metadata) {
        if (!this.assertType(metadata))
            return null;
        return new LookupFilterModel(metadata);
    }
}
export const lookupFilterParser = new LookupFilterParser();
export default new LookupFilterParser();
//# sourceMappingURL=lookup-filter-parser.js.map